import { connect } from 'react-redux';
import { login } from '../reducers/auth.reducers';
import Login from './login';

const mapDispatchToProps = dispatch => ({
  login: credentials => dispatch(login(credentials)),
});

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/login/login.container.js